import { useMediaQuery } from '@mui/material'
import cx from 'classnames'
import React, { useEffect, useState } from 'react'

import {
  TRANSITION_MULTI_POINT_MOVE_TO_CHECKOUT_DELAY,
  TRANSITION_MULTI_POINT_NEXT_POINT_INTERVAL
} from '@f/applications/QuizApp/partials/quizConstants'
import Icon from '@f/elements/Icon'

interface CheckoutTransitionInMultiPointProps {
  onTransitionEnd: () => void
  transitionInMultiPoint?: {
    title: string
    subtitle: string
    points: string[]
  }
  transitionTimeMultiplier?: number
}

const CheckoutTransitionInMultiPoint = ({
  onTransitionEnd,
  transitionInMultiPoint,
  transitionTimeMultiplier = 1
}: CheckoutTransitionInMultiPointProps) => {
  const isMobileView = useMediaQuery('(max-width: 901px)')

  const [processingPointIndex, setProcessingPointIndex] = useState(0)

  useEffect(() => {
    if (transitionInMultiPoint) {
      if (processingPointIndex < transitionInMultiPoint.points.length) {
        setTimeout(() => {
          setProcessingPointIndex(prev => prev + 1)
        }, transitionTimeMultiplier * TRANSITION_MULTI_POINT_NEXT_POINT_INTERVAL)
      } else {
        setTimeout(() => {
          onTransitionEnd()
        }, transitionTimeMultiplier * TRANSITION_MULTI_POINT_MOVE_TO_CHECKOUT_DELAY)
      }
    }
  }, [
    processingPointIndex,
    onTransitionEnd,
    transitionInMultiPoint,
    transitionTimeMultiplier
  ])

  if (!transitionInMultiPoint) {
    return null
  }

  return (
    <div
      className={cx(
        '[ f-overflow f-c-ba-bac025 ] QuizApp-transition',
        isMobileView ? 'f-m-t-060' : 'f-m-t-080'
      )}>
      <div className='f-wrap QuizApp-transition-multi-points'>
        <div className='f-t-tsection f-m-b-010'>
          {transitionInMultiPoint.title}
        </div>
        <div className='f-t-body f-m-b-040'>
          {transitionInMultiPoint.subtitle}
        </div>
        {transitionInMultiPoint.points.map((point, index) => {
          if (index < processingPointIndex) {
            return <CompletedPoint key={point} point={point} />
          }
          if (index === processingPointIndex) {
            return <ProcessingPoint key={point} point={point} />
          }
          return <PendingPoint key={point} point={point} />
        })}
      </div>
    </div>
  )
}

const CompletedPoint = ({ point }: { point: string }) => (
  <div className='f-d-flr f-fl-al-ce f-m-b-020' data-testId='point-completed'>
    <Icon icon='check-16px' className='f-icon-030 f-c-st-suc100 f-no-shrink' />
    <div className='f-t-body f-m-l-020'>{point}</div>
  </div>
)

const ProcessingPoint = ({ point }: { point: string }) => (
  <div className='f-d-flr f-fl-al-ce f-m-b-020' data-testId='point-processing'>
    <Icon
      icon='refresh-16px'
      className='f-icon-030 f-c-st-ter spin-animation f-no-shrink'
    />
    <div className='f-t-body f-m-l-020 f-c-fo-ter'>{point}</div>
  </div>
)

const PendingPoint = ({ point }: { point: string }) => (
  <div className='f-d-flr f-fl-al-ce f-m-b-020' data-testId='point-pending'>
    <Icon icon='check-16px' className='f-icon-030 f-c-st-neu100 f-no-shrink' />
    <div className='f-t-body f-m-l-020 f-c-fo-neu100'>{point}</div>
  </div>
)

export default CheckoutTransitionInMultiPoint
